export * from './user.constants';
const OPERATOR_REGEX=new RegExp(/[*/%+-]+/g);
export  {OPERATOR_REGEX};